import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getInternals(params: any): AxiosPromise {
    return EndPointService.get('/internals', { params });
}

function getInternal(id: number | string): AxiosPromise {
    return EndPointService.get(`/internals/${id}`);
}

function deleteInternal(id: number | string): AxiosPromise {
    return EndPointService.delete(`/internals/${id}`);
}

function createInternal(payload: any): AxiosPromise {
    return EndPointService.post('/internals', payload);
}

function updateInternal(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/internals/${id}`, { ...payload });
}

export default {
    getInternals,
    getInternal,
    deleteInternal,
    createInternal,
    updateInternal,
};
